// Feature flags configuration
const featureFlags = {
    // View modes
    calendar: {
        enabled: true,
        description: "Calendar view mode"
    },
    list: {
        enabled: true,
        description: "List view mode"
    },
    map: {
        enabled: true,
        description: "Map view mode"
    },
    weekViewButton: {
        enabled: true,
        description: "Week view mode"
    }
};

export default featureFlags; 